define('lib/analytics/textTrimmer',[], function () {
  return function txtTrimmer(textToClean) {
    var txt = textToClean || '';
    txt = txt.replace(/(\r\n|\n|\r)/gm, '').trim();
    txt = txt.replace(/ /g, '_'); // replace spaces with underscores, as requested
    return txt.replace(/(\r\n|\n|\r)/gm, '').trim();
  };
});

